import React from 'react';
import Helmet from 'components/Helmet';
import Content, { Col } from 'components/Content';
import AnimScroll from 'components/AnimationScroll';
import Button from 'components/Button'
import Link from 'components/Link'
// import Vimeo from 'components/Vimeo'
import styles from './styles.module.scss'

import img1 from '../images/gallery/cali-img2.jpg'
import img2 from '../images/gallery/cali-img1.jpg'

export default function Home({ data }) {
  return (
    <main>
      <Helmet
        title='Dance Choreographers & Chambelanes - Cali Dance XV'
        description='Need some choreography for your special dance? Learn more about Cali Dance XV, a dance studio based in Houston, Texas.'
      />
      <Content>
        <Col>
          <div className={styles.container}>
            <iframe className={styles.video} src='https://www.youtube.com/embed/C7Xyo8RALgA' frameBorder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowFullScreen />
          </div>
        </Col>
      </Content>
      <Content>
        <Col>
          <AnimScroll>
            <h1>Who We Are</h1>
            <p>
              Cali Dance XV is a dance studio based in Houston, Texas that choreographs different routines for your special night. We know your Quinceañera, Sweet 16, wedding, etc. is a once-in-a-lifetime event, so we will make sure you shine brightest on the dance floor.
            </p>
          </AnimScroll>
        </Col>
      </Content>
      <Content>
        <Col order='1' size='half'>
          <AnimScroll>
            <img src={img2} alt='Cali Dance XV custom choreography' />
          </AnimScroll>
        </Col>
        <Col size='half'>
          <AnimScroll>
            <h2>The Best Dance Choreography to Offer in Houston, Texas.</h2>
            <p>
              Give us the opportunity to come up with the best choreography for your waltz, as well as the surprise dance. Styles that we specialize in include:
            </p>
            <ul>
              <li>Salsa</li>
              <li>Cumbia</li>
              <li>Bachata</li>
              <li>Merengue</li>
              <li>Pop</li>
              <li>Reggaeton</li>
              <li>Tango</li>
              <li>Hip Hop, and more</li>
            </ul>
            <Link to='/gallery'>
              <Button>
                View Our Gallery
              </Button>
            </Link>
          </AnimScroll>
        </Col>
      </Content>
      <Content>
        <Col size='half'>
          <AnimScroll>
            <img src={img1} alt='Cali Dance XV Quinceañera' />
          </AnimScroll>
        </Col>
        <Col size='half'>
          <AnimScroll>
            <p>
              Many people love traditional dances, and others prefer a more modern style. That's okay. Our choreographers will make sure your Quinceañera, Sweet 16, wedding, or any other event is unique, exciting, and above all others.
            </p>
            <p>
              This is your chance to surprise your loved ones with a jaw-dropping  and original dance routine, whether it be a traditional or modern style. We guarantee you will have a special night that everyone will remember.
            </p>
            <p>
              We understand that every family has different needs. That's why we offer different packages and options to make sure everyone is able to have their moment.
            </p>
            <Link to='/contact'>
              <Button>
                Contact Us
              </Button>
            </Link>
          </AnimScroll>
        </Col>
      </Content>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/pages/index.js